import React from 'react';
import {Card, Tooltip} from "antd";
import {useRequest} from "ahooks";
import {CardProps} from "antd/lib/card";
import npiApi from "../../services/api";
import {IScheduledTaskType} from "../../contexts/internal-context";
import NpiDisplayDate from "../../components/display/date";
import {DevCardTitle} from "./dev-dashboard";
import { InfoCircleFilled } from '@ant-design/icons';


const NpiDashboardScheduledTasks = (props: CardProps) => {

    const {loading, data:tasks, run} = useRequest<IScheduledTaskType[], any>(npiApi.internal.dev.scheduledTasks);


    return <Card loading={loading} {...props} title={<DevCardTitle title={"Scheduled-Tasks last update"} onReload={run}/>}>

        {tasks && tasks.map((task) => (
            <div key={task.key} style={{paddingBottom: 10}}>
                <strong>{task.key} :</strong> <br/>
                <NpiDisplayDate value={task.updated_at || task.created_at} format={'YYYY-MM-DD HH:mm:ss'}/>
                {task.message && <Tooltip title={task.message}> &nbsp; <InfoCircleFilled/></Tooltip>}
            </div>
        ))}
    </Card>;
};

export default NpiDashboardScheduledTasks;